<template>
  <v-card>
    <v-container>
        <v-layout wrap>
            <v-flex xs12 md5>
                <div class="image-wrapper">
                    <v-img :src="imageSrc" max-height="300" contain />
                </div>
            </v-flex>
            <v-flex xs12 md7>
                <h2 class="">{{ product.name }}</h2>
                <p>{{ product.manufacturer }}</p>
                <p class="item-num">
                    Artikelnummer:<br>
                    <strong>{{ product.itemnum }}</strong>
                </p>
                <p class="item-num" v-if="product.barcode">
                    Barcode:<br>
                    <strong>{{ product.barcode }}</strong>
                </p>
                <p>
                    Verfügbare Menge:<br>
                    <strong>{{ product.stock.amount > 0 ? product.stock.amount : 0 }}</strong>
                </p>
            </v-flex>
        </v-layout>
        
        <v-divider />
        <v-tabs background-color="#E8E8E8">
            <v-tab href="#tab-description">Beschreibung</v-tab>
            <v-tab href="#tab-documents">Dokumente</v-tab>
            <v-tab href="#tab-videos" v-if="product.extdata.ytlink">Video</v-tab>

            <v-tab-item value="tab-description">
                <v-card
                    flat
                    tile
                >
                    <v-card-text 
                        v-if="config.field_definitions && config.field_definitions.description_field"
                        v-html="product.extdata.shop_description"
                    >
                    </v-card-text>
                    <v-card-text 
                        v-else
                        class="truncated-text pt-0"
                    >
                        {{ product.description }}
                    </v-card-text>
                </v-card>
            </v-tab-item>
            <v-tab-item value="tab-documents">
                <v-card
                    flat
                    tile
                >
                    <v-card-text v-if="product.extdata.document">
                        <a :href="product.extdata.document" target="_blank">Produktdatenblatt2</a>
                    </v-card-text>
                    <v-card-text else>Kein Produktdatenblatt verfügbar.</v-card-text>
                </v-card>
                <v-card
                    flat
                    tile
                >
                  <v-card-text v-if="product.extdata.document2">
                        <a :href="product.extdata.document2" target="_blank">Bedienungsanleitung</a>
                    </v-card-text>
                    <v-card-text else>Keine Bedienungsanleitung verfügbar.</v-card-text>
                </v-card>
            </v-tab-item>
            <v-tab-item value="tab-videos" v-if="product.extdata.ytlink">
                <v-card
                    flat
                    tile
                >
                    <v-card-text>
                        <div class="videoWrapper">
                            <iframe width="560" height="315" :src="'https://www.youtube.com/embed/' + product.extdata.ytlink" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        </div>
                    </v-card-text>
                </v-card>
            </v-tab-item>
        </v-tabs>
    </v-container>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ImageService } from "@/services/image.service";

export default {
    props: ["itemNumber"],

    data: () => ({
        imageSrc: null,
    }),

    created() {
        this.showItem();
    },
    
    computed: {
        ...mapGetters("product", ["product"]),
        ...mapGetters("account", ["selectedAccount"]),
        ...mapGetters("auth", ["userId"]),
        ...mapGetters("app", ["config"])
    },

    watch: {
        itemNumber: function() {
            this.showItem();
        }
    },

    methods: {
        ...mapActions("product", ["showProduct"]),

        showItem() {
            console.log("bild", this.item.extdata.shop_primary_image)
            if (this.product && this.product.itemnum === this.itemNumber) {
                return false;
            }

            let accountId = this.selectedAccount ? this.selectedAccount.ID : this.userId;
            this.showProduct({ account: accountId, search: this.itemNumber })
                             
                .then(() => { 
                    if (typeof this.item.extdata.shop_primary_image == "undefined") {    
                        if (!this.item.image) {
                            return;
                        }

                        ImageService.getImageSrc(this.item.item)
                            .then((res) => {
                                this.imageSrc = "data:image/png;base64," + res;
                            })
                        } else {
                        
                        this.imageSrc = this.item.extdata.shop_primary_image;
                        
                    }
      
            })/*{
                    ImageService.getImageSrc(this.product.item)
                        .then((res) => {
                            this.imageSrc = "data:image/png;base64," + res;
                        })
                })*/
        }
    }
}
</script>
